export const CORE_BENEFITS = {
  // packagePicker.block.packages.core_access.benefits
  core_access: ['customize', 'storage', 'monetize', 'protect', 'dreamup'],
  // packagePicker.block.packages.core_plus.benefits
  core_plus: ['customize', 'storage', 'monetize', 'protect', 'dreamup'],
  // packagePicker.block.packages.core_pro.benefits
  core_pro: ['sellAndPromote', 'monetize', 'customize', 'storage', 'dreamup'],
  // packagePicker.block.packages.core_pro_plus.benefits
  core_pro_plus: [
    'sellAndPromote',
    'monetize',
    'customize',
    'storage',
    'portfolio',
    'dreamup',
  ],
};
